<template>
    <div class="container">
        <div class="filter">
            <div class="select">
                <el-select v-model="eventType" @change="$emit('filter', eventType)">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="select">
                <el-select v-model="eventType1" @change="$emit('filter1', eventType1)">
                    <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="select">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    unlink-panels
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    :default-time="['00:00:00', '23:59:59']"
                    @change="$emit('query', dateRange)">
                </el-date-picker>
            </div>
            <div class="select">
                <el-button type="primary">查询</el-button>
            </div>
        </div>
        <div class="count" v-if="this.$route.params.classify=='unconfirmed'">
            <el-button type="" @click="makeSure">一键确认事件</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        count: Number,
        types: Array,
        classify:String
    },
    data () {
        return {
            dateRange:"",
            eventType1:"",
            eventType:"",
            grade:['紧急','隐患','通知'],
            type:['保护动作','故障报警','开关变位','越限异常','信息通报','操作命令','其他告警']
        }
    },
    methods:{
        makeSure(){
            this.$emit('makeSure',true)
        }
    },
    computed: {
        options: function () {
            let op = this.grade.map(item => {
                return {
                    value: item,
                    label: item,
                }
            })
            op.unshift({label: '全部等级', value: ''});
            return op;
        },
        options1: function () {
            let op = this.type.map(item => {
                return {
                    value: item,
                    label: item,
                }
            })
            op.unshift({label: '全部类型', value: ''});
            return op;
        }
    },
    watch: {
        
    }
}
</script>

<style lang="less" scoped>
.container {
    .h(88);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 1px;
    background: white;
}
.filter {
    display: flex;
    padding-left: 24rem;
}
.el-select {
    .w(260);
}
.date-picker {
    // padding-left: 24rem;
}
.select{
    padding-right: 24rem;
}
.button {
    padding-left: 24rem;
}
.count {
    padding-right: 24rem;
    font-size: 18rem;
    font-weight: 500;

    span {
        color: #0D94FF;
    }
}
</style>